import React from 'react'
import { connect } from 'react-redux'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import { T } from 'components/components/i18n'
import Checkbox from '../../Checkbox'
import styles from './styles.less'

const conditionOptions = {
  'new': <T id="New" />,
  'used': <T id="Used" />,
  'olddot': <T id="Old DOT" />,
  'unused': <T id="Unused" />
}

const Condition = (props) => {
  const { selectedOptions, onChange, config, order } = props
  const onCheckboxChange = (value) => {
    let  selectedOptionsNew
    const checked = selectedOptions.indexOf(value) !== -1
    if (checked)
      selectedOptionsNew = selectedOptions.filter(option => option !== value)
    else {
      selectedOptionsNew = selectedOptions.slice()
      selectedOptionsNew.push(value)
    }
    onChange('condition', selectedOptionsNew)
  }

  let conditionCheckboxes = [], productTypes = []
  if (Array.isArray(order) && order.length) {
    productTypes = order
  } else {
    productTypes = Object.keys(conditionOptions)
  }
  productTypes.forEach (productType => {
    if (config[productType] && config[productType].show)
      conditionCheckboxes.push(
        <Checkbox
          inline
          onChange={onCheckboxChange}
          value={productType}
          name={productType}
          key={productType}
          label={conditionOptions[productType]}
          className={styles.checkbox}
          isChecked={selectedOptions.indexOf(productType) > -1}
        />
      )
  })

  if (!conditionCheckboxes.length)
    return null
  return (
    <FormGroup className={`${styles.wrapper} condition`}>
      <ControlLabel><T id="Condition"/></ControlLabel>
      {conditionCheckboxes}
    </FormGroup>
  )
}

const mapStateToProps = state => {
  return {
    order: state?.shop?.topBrandsConfig?.condition?.['order']
  }
}

export default connect(mapStateToProps)(Condition)

